<template>
  <b-dropdown
    size="lg"
    variant="link"
    toggle-class="text-decoration-none"
    no-caret
  >
    <template slot="button-content">
      <a
        role="button"
        class="video-options-button"
        data-cy="video-options-button"
      >
        <span>
          <i class="fas fa-circle fa-stack-1x icon-a" />
          <i class="fas fa-plus-circle fa-stack-1x icon-b" />
        </span>
      </a>
    </template>
    <b-dropdown-item
      v-for="(option, index) in options"
      :key="index"
      @click="performAction(option.action)"
    >
      {{ option.label }}
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
export default {
  data() {
    return {
      options: [
        {
          label: 'View Post Details',
          action: 'view-post-details',
        },
        {
          label: 'View Channel Details',
          action: 'view-channel-details',
        },
      ],
    };
  },

  methods: {
    performAction(action) {
      console.log('performAction', action);
    },
  },
};
</script>

<style scoped>
.video-options-button {
  font-size: 20px;
  cursor: pointer;
}

.video-options-button .icon-a {
  color: #fff;
}
.video-options-button .icon-b {
  color: #666;
}
</style>
